import { ReactNode } from 'react';

export const getCarouselSlideItems = (
  items: ReactNode | ReactNode[],
  itemsPerSlide = 1,
): ReactNode[] => {
  if (!items) return [];

  const childrenArr = Array.isArray(items) ? items : [items];

  return childrenArr.reduce<ReactNode[][]>((rows, key, idx) => {
    if (!(idx % itemsPerSlide)) {
      rows.push([key]);
    } else {
      rows[rows.length - 1].push(key);
    }

    return rows;
  }, []);
};
